var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79839 0.853553C9.99365 0.658291 9.99365 0.341709 9.79839 0.146447C9.60313 -0.0488155 9.28654 -0.0488155 9.09128 0.146447L4.97266 4.26507L0.854032 0.146447C0.65877 -0.0488155 0.342187 -0.0488155 0.146925 0.146447C-0.0483379 0.341709 -0.0483379 0.658291 0.146925 0.853553L4.26555 4.97218L0.146447 9.09128C-0.0488155 9.28654 -0.0488155 9.60313 0.146447 9.79839C0.341709 9.99365 0.658291 9.99365 0.853553 9.79839L4.97266 5.67928L9.09176 9.79839C9.28702 9.99365 9.6036 9.99365 9.79887 9.79839C9.99413 9.60313 9.99413 9.28654 9.79887 9.09128L5.67976 4.97218L9.79839 0.853553Z",
    fill: "#517E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCross);
export default __webpack_public_path__ + "static/media/remove-cross.47ff5a370f9730ee485d46a039ee302c.svg";
export { ForwardRef as ReactComponent };